import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DownloadIcon } from '../../svg/downloadIcon.svg';
import MenuIcon from '@mui/icons-material/Menu';
import { useCart } from '../Context/CardContext';

const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { items } = useCart();
    const cartItemCount = items.length;

    const handleNavigation = (path: string) => {
        navigate(path);
        setMenuOpen(false);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Schließe das mobile Menü, wenn die Fenstergröße geändert wird
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768 && menuOpen) {
                setMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [menuOpen]);

    return (
        <header>
            <nav>
                <div className="logo-container" onClick={() => handleNavigation('/')} style={{ cursor: 'pointer' }}>
                    <img src="/img.png" height={50} alt="BM Maps Logo" className="logo" />
                </div>
                <div className="mobile-menu-icon" onClick={toggleMenu}>
                    <MenuIcon />
                </div>
                <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
                    <li className={location.pathname === '/Transformation' ? 'active' : ''}>
                        <Link to="/Transformation" className="geschäftsmodell-transformation-link">
                            Geschäftsmodell<br />Transformation
                        </Link>
                    </li>
                    <li className={location.pathname === '/Trends' ? 'active' : ''}>
                        <Link to="/Trends" className="trends-link">
                            Geschäftsmodell<br />Trends
                        </Link>
                    </li>
                    <li className={location.pathname === '/Know-How' ? 'active' : ''}>
                        <Link to="/Know-How" className="know-how-link">
                            Geschäftsmodell<br />Know-how
                        </Link>
                    </li>
                    <li className={location.pathname === '/Konakt' ? 'active' : ''}>
                        <Link to="/Konakt" className="partner-link">
                            Kontakt
                        </Link>
                    </li>
                    <li className="cart-container">
                        <Link to="/Warenkorb" className={`cart-link ${location.pathname === '/Warenkorb' ? 'active' : ''}`}>
                            <div className={`download-icon-container ${isMobile ? 'mobile' : 'desktop'}`}>
                                <DownloadIcon className="cart-icon" />
                                {cartItemCount > 0 && (
                                    <span className={`cart-badge ${isMobile ? 'mobile' : ''}`}>
                    {cartItemCount > 99 ? '99+' : cartItemCount}
                </span>
                                )}
                            </div>
                        </Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Navbar;